// js-buy-votes-form.js
; (() => {
    document.querySelectorAll(".js-buy-votes-form").forEach(form => {
        const ratio1 = parseFloat(form.dataset.ratio1) || 0
        const ratio2 = parseFloat(form.dataset.ratio2) || 0
        const currency = form.dataset.currency || ''
        const input = form.querySelector('.js-buy-votes-form-input')
        const output = form.querySelector('.js-buy-votes-form-output')

        let componentsError = false

        if (!input) {
            console.error('No input for buy votes form')
            componentsError = true
        }

        if (!output) {
            console.error('No output for buy votes form')
            componentsError = true
        }

        if (componentsError) { return }

        input.addEventListener('input', event => {
            const value = parseInt(event.target.value) || 0
            const result = value * ratio1 * ratio2

            // const outputResult = (result < 0.01 ? result : result.toFixed(2)) + currency
            const outputResult = Math.ceil(result).toFixed(0) + currency
            output.value = outputResult
        })
    })

})();